import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { ThemeMode } from "@smartsheet/sds-theme-internal";
import { InputFieldBaseProps } from "../../../../util/inputFieldBaseProps";
import { withFocusToggleClassName } from "../../../../util/withFocusClassName";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { TextAreaV2 } from "../../../textareaV2";

export interface ComboBoxTextareaProps extends InputFieldBaseProps {
    themeMode: ThemeMode;
}

export const ComboboxTextArea = withFocusToggleClassName(styled(TextAreaV2)<ComboBoxTextareaProps>`
    display: block;
    width: 100%;
    border: none;
    color: ${color("color--text--neutral--strong")};

    // Override some UA styles.
    font-family: inherit;
    font-size: ${({ themeMode }) => menuTheme.fontSize(themeMode)};

    &:focus-within::before {
        border: none;
        box-shadow: none;
    }
`);
